// extracted by mini-css-extract-plugin
export var box = "_8b-1";
export var checked = "_8b-2";
export var descriptionSpacer = "_8b-9";
export var disabled = "_8b-3";
export var icon = "_8b-6";
export var input = "_8b-0";
export var labelSpacer = "_8b-8";
export var medium = "_8b-5";
export var small = "_8b-4";
export var text = "_8b-7";